import { NgModule } from '@angular/core';
import { MatDialogModule, MatButtonModule } from '@angular/material';
import { CuiAlertDialogComponent } from './alert-dialog.component';

@NgModule({
  imports: [
    MatButtonModule,
    MatDialogModule
  ],
  declarations: [
    CuiAlertDialogComponent
  ],
  entryComponents: [
    CuiAlertDialogComponent
  ],
  exports: [
    CuiAlertDialogComponent
  ]
})
export class CuiAlertDialogModule {}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/dialogs/alert-dialog/alert-dialog.module.ts